import React from 'react';
import {connect} from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  withStyles} from '@material-ui/core';

import {closeModal, openModalCB_3,closeModal_2,closeModalCB_3} from "./../../actions/CustomerActions"
import FullScreenDialog from "./FullScreenDialog.jsx";
import * as PaymentActions from "../../actions/PaymentActions";


import Ribform from "./Ribform.jsx"
import styles from "./customMaterialUIStyle"

@connect(store => {
	return {
  customer: store.customer.customer,
  messageError: store.customer.message || "",
  ingenico: store.ingenico.ingenico || {},
  status: store.ingenico.status,
  messages:store.messages.messages,
  showModalCB_3:  store.customer.showModalCB_3
}})

 class PaymentMethodIngenicoDailog extends React.Component {
  state = {
    isOpen : false,
    _isOpen : false
  };

  handleClose = (event) => {
    event && event.preventDefault();
    this.props.dispatch(closeModal());
    this.props.dispatch(closeModalCB_3());
    this.props.dispatch(closeModal_2());
    this.setState({_isOpen : false})
  };

  renderIngenico = (customerAccount) => {
    const encodedURL = encodeURIComponent(`${window.location.origin}${INGENECOLOADER}`);
    const args = `&ca=${customerAccount.code}&returnUrl=${encodedURL}`;
    this.props.dispatch(PaymentActions.openIngenico(args));
  }

    handleClickOpen = (e,customerAccount) => {
      e.preventDefault;
      const {paymentType} = this.props.paymentMethod;

      if(paymentType === "DIRECTDEBIT"){
        this.setState({//open ingenico
          _isOpen : false,
          isOpen : true
        })
        this.renderIngenico(customerAccount)
      }

      if(paymentType === "CARD"){
        setTimeout(() => {
          this.setState({// open Rib form
            _isOpen : true,
            isOpen : false
          })
        }, 200);
        }
      this.props.dispatch(openModalCB_3())//hide message dialog
    };

  render() {
    const {classes, customerAccount, dispatch, titles, button,dialogMSG, dialogTitle,subscription, user, messages, paymentMethod,showModalCB_3,status,ingenico ,offer,open} = this.props;
    const {_isOpen,isOpen} = this.state;
    return (
      <div class="text-center">
        { _isOpen &&
        <Ribform offer={offer} subscription={subscription} customerAccount={customerAccount} open={open} paymentMethod={paymentMethod} />
        }
         {!showModalCB_3 &&
        <Dialog
          open={!showModalCB_3}
          aria-labelledby="simple-dialog-title"
          maxWidth="md"
          className={classes.width}
          >
            <DialogTitle id="form-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
              <Grid>
                <label className={classes.label}>{dialogMSG}</label>
              </Grid>

            </DialogContent>
            <DialogActions className={classes.margin}>
              <Button onClick={this.handleClose} variant="contained" className={classes.button}>
                      {messages["common.button.cancel"]}
              </Button>
              <Button onClick={e=>this.handleClickOpen(e,customerAccount) } variant="contained" className={classes.button}>
                      {messages["common.button.continue"]}
              </Button>

            </DialogActions>
          </Dialog>
          }
          {isOpen &&
          <FullScreenDialog dispatch={dispatch} paymentMethod={paymentMethod} status={status} ingenico={ingenico}/>
          }

        </div>
      );
  }
}
export default withStyles(styles)(PaymentMethodIngenicoDailog);



// WEBPACK FOOTER //
// ./src/opencell/pages/client/PaymentMethodIngenicoDailog.jsx